import { apiConfig } from '@bonanza-social/toolkit/api';
import { startListening } from '@bonanza-social/toolkit/state';
import { ChatService } from '@bonanza-social/chat';
import {
  selectAuth,
  selectGroupId,
  groupUpdated,
  updateSessionVariables,
} from '@bonanza-social/chat/state';
import { setAccount, selectAccount, getAccount } from '@bonanza-social/account/state';
import { selectCoinBalance } from '@bonanza-social/wallet/state';
import { selectStatus } from '@bonanza-social/status/state';

startListening({
  actionCreator: groupUpdated,
  effect: ({ payload: liveChatGroupId }, { dispatch }) => {
    dispatch(setAccount({ liveChatGroupId }));
  },
});

startListening({
  actionCreator: getAccount.fulfilled,
  effect: ({ payload }, { dispatch, getState }) => {
    const { liveChatGroupId } = payload;
    const currentGroupId = selectGroupId(getState());

    if (liveChatGroupId !== undefined && currentGroupId !== liveChatGroupId) {
      dispatch(groupUpdated(liveChatGroupId));
    }
  },
});

startListening({
  actionCreator: updateSessionVariables,
  effect: async (_, { getState }) => {
    const state = getState();
    const auth = selectAuth(state);
    const account = selectAccount(state);
    const coinBalance = selectCoinBalance(state);
    const status = selectStatus(state);
    const userId = await apiConfig.getUserId();

    await ChatService.updateSessionVariables({
      data: {
        liveChatCustomerId: auth?.entityId,
        accountStatus: account?.status,
        accountStatusReason: account?.statusReason,
        registrationEmail: account?.email,
        coinBalance,
        playerStatus: status?.playerStatus,
      },
      pathParams: {
        userId: userId || '-1',
      },
    });
  },
});
